import type { FeatureStyleNode } from '../feature-style.model';

// =============================================================================
// PARAMS - Feature configuration from widget config
// =============================================================================

/** Monotonicity feature parameters */
export interface MonotonicityParams {
  /** Reference to parent function element */
  of: string;
}

export const MONOTONICITY_DEFAULT_PARAMS: Omit<MonotonicityParams, 'of'> = {};

/**
 * Default theme for monotonicity feature.
 * Green for increasing regions, red for decreasing regions.
 *
 * Structure:
 * - polygon.visible: Whether to show background polygons (default: true)
 * - curve.visible: Whether to show colored curve segments (default: false)
 * - subparts.increasing: Style for increasing regions (f'(x) > 0)
 * - subparts.decreasing: Style for decreasing regions (f'(x) < 0)
 */
export const MONOTONICITY_DEFAULTS: FeatureStyleNode = {
  polygon: {
    visible: true,
    fillOpacity: 0.15,
    strokeWidth: 0,
  },
  curve: {
    visible: false,
  },
  subparts: {
    increasing: {
      polygon: { fillColor: 'green' },
      curve: { color: 'green' },
    },
    decreasing: {
      polygon: { fillColor: 'red' },
      curve: { color: 'red' },
    },
  },
};
